import React, { useState } from "react";
import { Button } from "react-bootstrap";
import ProductsLearnMoreModal from "./ProductsLearnMoreModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";

export default function ProductsAssetManagement() {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleLearnMoreClick = (event, product) => {
    event.preventDefault();
    event.stopPropagation();
    setSelectedProduct(product);
  };

  const handleCloseModal = () => {
    setSelectedProduct(null);
  };

  return (
    <div className="bg-page rounded-4 p-3 mb-5">
      <div className="text-center mb-4">
        <img
          src="/assets/products/images/asset.png"
          alt="Asset Management"
          className="img-fluid rounded-4"
          style={{ maxHeight: "280px", objectFit: "cover" }}
        />
        <div className="fw-bold text-navy text-center fs-2 mt-3">
          Asset Management
        </div>
      </div>

      <div>
        <p className="fs-5 mt-3">
          Managing assets at scale, whether physical, fixed, portable, or
          digital, is increasingly complex.
        </p>
        <p className="fs-5 ">
          The real challenge isn’t just visibility but the ability to quickly
          group, manage, and communicate with the people connected to those
          assets, especially during high-pressure situations.
        </p>
        <p className="fs-5 ">
          Boomerang provides a centralised platform to register, manage and
          engage with assets and their associated contacts through a real-time,
          map-based interface. This gives teams a clear operational view and the
          ability to act immediately when it matters.
        </p>
        <p className="fs-5 ">
          Events can be triggered automatically through monitoring or initiated
          manually. From there, Boomerang orchestrates the response, either
          through predefined workflows or controlled manual intervention.
        </p>
        <p className="fs-5 ">
          Teams can issue communications, create and manage tickets, add notes,
          involve additional stakeholders, and maintain control over SLA-driven
          responses throughout the event lifecycle.
        </p>
        <p className="fs-5 ">
          Assets can be grouped dynamically, with communications and escalation
          paths tailored to the situation. This ensures that responses remain
          structured, consistent, and aligned to operational priorities, even as
          conditions change.
        </p>
        <p className="fs-5 ">
          Real-time reporting keeps key stakeholders informed during an event,
          while post-event reporting provides the insight needed to review
          performance and continuously improve processes.
        </p>
        <p className="fs-5 ">
          The result is simple: complete visibility of your assets, structured
          control during events, and reliable communication when it matters
          most.
        </p>
        <p className="fs-5 ">
          Asset Management within Boomerang can also be combined with:
        </p>
        <p>
          <div className="align-items-center gap-2">
            <a
              href="/workflows/products/monitoringAndAlerting"
              className="text-decoration-none text-navy"
            >
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">Monitoring</span>
            </a>
          </div>
          <div className="align-items-center gap-2">
            <a
              href="/workflows/products/eventsAndAlerting"
              className="text-decoration-none text-navy"
            >
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">Events and Alerting</span>
            </a>
          </div>
          <div className="align-items-center gap-2">
            <a
              href="/workflows/products/solutions"
              className="text-decoration-none text-navy"
            >
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">Solutions</span>
            </a>
          </div>
          <div className="align-items-center gap-2">
            <a
              href="/workflows/products/assetManagement"
              className="text-decoration-none text-navy"
            >
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">Assets</span>
            </a>
          </div>
        </p>
      </div>

      <div className="text-center d-flex justify-content-center gap-3 mt-4">
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "trial" })}
        >
          Free trial
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "buy" })}
        >
          Buy
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) =>
            handleLearnMoreClick(event, { name: "more information" })
          }
        >
          More Information
        </Button>
        <ProductsLearnMoreModal
          selectedProduct={selectedProduct}
          handleCloseModal={handleCloseModal}
        />
      </div>
    </div>
  );
}
